import React from 'react'
import { BrowserRouter, Routes ,Route } from 'react-router-dom'

// import pages
import Home from '../pages/home/Home'
import Projects from '../pages/projects/Projects';
import About from '../pages/about/About';
import Games from '../pages/games/Games';

export default function src(){
  return(
    <BrowserRouter>
      <Routes>

        <Route path="/"         exact element={<Home />} />
        <Route path="/projects" exact element={<Projects  index={1} />} />
        <Route path="/games"    exact element={<Games     index={2} />} />
        <Route path="/about"    exact element={<About     index={3} />} />

      </Routes>
    </BrowserRouter>
  );
}